export default function useValidator () {
    return {
        $_veeValidate: {
            validator: 'new', // give me a new validator each time.
        },
    };
}
